import { useState } from 'react';
import { useUserAvatar } from './useUserAvatar';

export const useProfilePicture = (userId, options = {}) => {
    const {
        avatarUrl,
        rawUrl,
        setAvatarUrl,
        refreshAvatar,
        shouldUseSupportAvatar,
    } = useUserAvatar(userId, { enabled: options.enabled !== false });

    const [showProfilePictureUpload, setShowProfilePictureUpload] = useState(false);
    const [showProfilePicturePreview, setShowProfilePicturePreview] = useState(false);

    const handleProfilePictureUpdate = (newAvatarUrl) => {
        // Normalize in userProfileService to keep URL handling in one place.
        setAvatarUrl(newAvatarUrl || null);
    };

    return {
        showProfilePictureUpload,
        setShowProfilePictureUpload,
        profilePicture: avatarUrl,
        rawProfilePicture: rawUrl,
        setProfilePicture: setAvatarUrl,
        showProfilePicturePreview,
        setShowProfilePicturePreview,
        handleProfilePictureUpdate,
        refreshAvatar,
        shouldUseSupportAvatar,
    };
};
